import { TextField } from '@material-ui/core';
import { withHelperText } from '../HOC/with-helper-text';
import { CheckboxWithLabel } from './checkbox-with-label';

export const TextFieldWithHelperText = withHelperText(TextField);
export const CheckBoxWithHelperText = withHelperText(CheckboxWithLabel);
